import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  class: "carousel-container"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "pointers d-flex" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 16 }
const _hoisted_7 = { class: "text-error" }

import {
  ref,
  watch,
  onMounted,
  onBeforeUnmount,
  computed,
  reactive,
} from "vue";
import WeatherWidget from "@/components/dynamic/WeatherWidget.vue";
import DateWidget from "@/components/dynamic/DateWidget.vue";
import ClockWidget from "@/components/dynamic/ClockWidget.vue";
import ExchangeTable from "@/components/dynamic/ExchangeTable.vue";
import ExchangeTicker from "@/components/dynamic/ExchangeTicker.vue";
import QueueDefaultWidget from "@/components/dynamic/QueueDefaultWidget.vue";
import Ticker from "@/components/dynamic/Ticker.vue";
import VideoWidget from "@/components/dynamic/VideoWidget.vue";
// import MultiVideoWidget from "@/components/dynamic/MultiVideoWidget.vue";
import WidgetMultiVideo from "@/components/dynamic/WidgetMultiVideo.vue";
import ForecastWidget from "@/components/dynamic/ForecastWidget.vue";

const __default__ = {
  name: "WidgetApp",
};


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    config: {},
    queueData: {},
    queueConfig: {},
    queueAudioPlaying: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

//carousel
const activeItem = ref<string | null>(null);
const carouselTimer = ref<number | null>(null);
const isTransitioning = ref(false);
const slideDirection = ref<"next" | "prev">("next");
const currentIndex = ref(0);

const goToNextItem = () => {
  if (!props.config?.srcList?.length) return;

  if (activeItem.value === null) {
    currentIndex.value = 0;
    activeItem.value = props.config.srcList[0];
  } else {
    slideDirection.value = "next";
    // Find current index
    const idx = props.config.srcList.indexOf(activeItem.value);
    currentIndex.value = idx;
    const nextIndex = (idx + 1) % props.config.srcList.length;

    // Set transitioning flag to prevent multiple simultaneous transitions
    isTransitioning.value = true;
    activeItem.value = props.config.srcList[nextIndex];

    // Reset transitioning flag after animation completes
    setTimeout(() => {
      isTransitioning.value = false;
    }, 500); // Match this with the CSS transition duration
  }
};

const goToPrevItem = () => {
  if (!props.config?.srcList?.length) return;

  slideDirection.value = "prev";

  // Find current index
  const idx = props.config.srcList.indexOf(activeItem.value);
  currentIndex.value = idx;
  const prevIndex =
    (idx - 1 + props.config.srcList.length) % props.config.srcList.length;

  isTransitioning.value = true;
  activeItem.value = props.config.srcList[prevIndex];

  setTimeout(() => {
    isTransitioning.value = false;
  }, 500);
};

const startCarouselTimer = () => {
  if (carouselTimer.value) {
    clearTimeout(carouselTimer.value);
  }

  carouselTimer.value = setTimeout(
    () => {
      if (!isTransitioning.value) {
        goToNextItem();
      }
      startCarouselTimer();
    },
    props.config.interval ? props.config.interval : 5000
  );
};

const selectItem = (item: string) => {
  if (isTransitioning.value || activeItem.value === item) return;

  const newIndex = props.config.srcList.indexOf(item);
  const currentIdx = props.config.srcList.indexOf(activeItem.value);

  if (newIndex > currentIdx) {
    slideDirection.value = "next";
  } else if (newIndex < currentIdx) {
    slideDirection.value = "prev";
  }

  isTransitioning.value = true;
  activeItem.value = item;

  setTimeout(() => {
    isTransitioning.value = false;
  }, 500);

  startCarouselTimer();
};

//video
const videoRef = ref<HTMLVideoElement | null>(null);

//weather
const weatherWidget = ref<any>(null);
const loading = ref(false);

const state = reactive({
  forecastData: {
    forecastday: []
  }
});

const updateForecastData = (data: any) => {
  console.log("Widget: Received forecast data update:", data);
  if (data && data.forecastday && Array.isArray(data.forecastday)) {
    state.forecastData = JSON.parse(JSON.stringify(data));
    console.log("Widget: Updated forecast data in state:", state.forecastData);
  }
};


watch(
  () => weatherWidget.value?.loading,
  (newLoading) => {
    loading.value = newLoading || false;
  }
);

onMounted(() => {
  // init carousel
  if (props.config?.type === "carousel" && props.config?.srcList?.length > 0) {
    goToNextItem();
    startCarouselTimer();
  }
});

// Clean up timer on unmount
onBeforeUnmount(() => {
  if (carouselTimer.value) {
    clearTimeout(carouselTimer.value);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "widget-root",
    style: _normalizeStyle({
      '--carousel-delimiter-color': _ctx.config?.delimiterColor || '#bdbdbd',
      '--image-option': _ctx.config?.option || 'fill',
      '--separator-color': _ctx.config?.seperatorColor || '#000000',
      '--separator-padding': (_ctx.config?.separatorPadding || 10) + 'px',
    })
  }, [
    (_ctx.config?.type === 'image')
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.config?.src,
          class: "image-fill"
        }, null, 8, _hoisted_1))
      : (_ctx.config?.type === 'carousel')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_Transition, {
              name: slideDirection.value === 'next' ? 'slide-next' : 'slide-prev'
            }, {
              default: _withCtx(() => [
                (activeItem.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      src: activeItem.value,
                      class: "image-fill carousel-image",
                      key: activeItem.value
                    }, null, 8, _hoisted_3))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["name"]),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config?.srcList, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item,
                  class: _normalizeClass(["pointer", { 'active-pointer': item === activeItem.value }]),
                  onClick: ($event: any) => (selectItem(item))
                }, null, 10, _hoisted_5))
              }), 128))
            ])
          ]))
        : (_ctx.config.type === 'video' && !_ctx.config?.multiVideo && _ctx.config?.visible)
          ? (_openBlock(), _createBlock(VideoWidget, {
              key: 2,
              config: _ctx.config,
              queueAudioPlaying: _ctx.queueAudioPlaying
            }, null, 8, ["config", "queueAudioPlaying"]))
          : (_ctx.config.type === 'video' && _ctx.config?.multiVideo && _ctx.config?.visible)
            ? (_openBlock(), _createBlock(WidgetMultiVideo, {
                key: 3,
                config: _ctx.config,
                queueAudioPlaying: _ctx.queueAudioPlaying
              }, null, 8, ["config", "queueAudioPlaying"]))
            : (_ctx.config?.type === 'app' && _ctx.config?.appType === 'weather')
              ? (_openBlock(), _createBlock(WeatherWidget, {
                  key: 4,
                  ref_key: "weatherWidget",
                  ref: weatherWidget,
                  city: _ctx.config?.city || 'Tunis',
                  unit: _ctx.config?.unit || 'Celsius',
                  "font-size": Number(_ctx.config.fontSize) || 40,
                  "font-family": _ctx.config?.fontFamily || 'Arial',
                  "font-color": _ctx.config?.fontColor || '#FFFFFF',
                  "background-color": _ctx.config?.backgroundColor || '#03A9F4',
                  opacity: _ctx.config?.opacity !== undefined ? _ctx.config?.opacity : 1,
                  height: _ctx.config?.height || 200,
                  width: _ctx.config?.width || 300,
                  "border-radius": _ctx.config?.borderRadius || 0,
                  "onUpdate:forecastData": updateForecastData
                }, null, 8, ["city", "unit", "font-size", "font-family", "font-color", "background-color", "opacity", "height", "width", "border-radius"]))
              : (_ctx.config?.type === 'app' && _ctx.config?.appType === 'date')
                ? (_openBlock(), _createBlock(DateWidget, {
                    key: 5,
                    "font-family": _ctx.config?.fontFamily || 'Arial',
                    "font-size": Number(_ctx.config.fontSize) || 40,
                    "font-color": _ctx.config?.fontColor || '#FFFFFF',
                    "font-weight": _ctx.config?.fontWeight || 'normal'
                  }, null, 8, ["font-family", "font-size", "font-color", "font-weight"]))
                : (_ctx.config?.type === 'app' && _ctx.config?.appType === 'clock')
                  ? (_openBlock(), _createBlock(ClockWidget, {
                      key: 6,
                      "time-format": _ctx.config?.timeFormat || '24h',
                      "show-seconds": _ctx.config?.showSeconds || false,
                      "font-family": _ctx.config?.fontFamily || 'Arial',
                      "font-size": Number(_ctx.config?.fontSize) || 40,
                      "font-color": _ctx.config?.fontColor || '#FFFFFF',
                      "font-weight": _ctx.config?.fontWeight || 'normal'
                    }, null, 8, ["time-format", "show-seconds", "font-family", "font-size", "font-color", "font-weight"]))
                  : (
        _ctx.config.type === 'app' &&
        _ctx.config.appType === 'exchange' &&
        _ctx.config.exchangeType === 'table'
      )
                    ? (_openBlock(), _createBlock(ExchangeTable, {
                        key: 7,
                        "header-color": _ctx.config.headerColor || '#000000',
                        "text-color": _ctx.config.textColor || '#000000',
                        header: _ctx.config.header || []
                      }, null, 8, ["header-color", "text-color", "header"]))
                    : (
        _ctx.config.type === 'app' &&
        _ctx.config.appType === 'exchange' &&
        _ctx.config.exchangeType === 'ticker'
      )
                      ? (_openBlock(), _createBlock(ExchangeTicker, {
                          key: 8,
                          "values-color": _ctx.config.valuesColor || '#000000',
                          "text-color": _ctx.config.textColor || '#000000',
                          "flag-txt-color": _ctx.config.flagTxtColor || '#000000',
                          separator: _ctx.config.separator || '|',
                          "separator-color": _ctx.config.separatorColor || '#000000',
                          "separator-padding": Number(_ctx.config.separatorPadding) || 10,
                          "background-color": _ctx.config.backgroundColor || '#000000',
                          "ticker-speed": _ctx.config.tickerSpeed || 10,
                          config: _ctx.config
                        }, null, 8, ["values-color", "text-color", "flag-txt-color", "separator", "separator-color", "separator-padding", "background-color", "ticker-speed", "config"]))
                      : (
        _ctx.config.type === 'app' &&
        _ctx.config.appType === 'queue' &&
        _ctx.queueData.length > 0
      )
                        ? (_openBlock(), _createBlock(QueueDefaultWidget, {
                            key: 9,
                            queueData: _ctx.queueData,
                            queueConfig: _ctx.queueConfig,
                            "border-radius": _ctx.config?.borderRadius || 0,
                            config: _ctx.config
                          }, null, 8, ["queueData", "queueConfig", "border-radius", "config"]))
                        : (
        _ctx.config.type === 'app' &&
        _ctx.config.appType === 'queue' &&
        _ctx.queueData.length === 0
      )
                          ? (_openBlock(), _createBlock(ForecastWidget, {
                              key: 10,
                              loading: loading.value,
                              "border-radius": _ctx.config?.borderRadius || 0,
                              config: _ctx.config
                            }, null, 8, ["loading", "border-radius", "config"]))
                          : (
        _ctx.config?.type === 'clipart' &&
        (_ctx.config?.name === 'Rectangle' || _ctx.config?.name === 'Square')
      )
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 11,
                                style: _normalizeStyle({
        width: '100%',
        height: '100%',
        background: _ctx.config.fillColor || '#000',
        border:
          (_ctx.config?.strokeWidth || 1) +
          'px solid ' +
          (_ctx.config?.outlineColor || '#000'),
        borderRadius: _ctx.config?.name === 'Square' ? '0' : '0',
      })
                              }, null, 4))
                            : (_ctx.config?.type === 'clipart' && _ctx.config?.name === 'Circle')
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 12,
                                  style: _normalizeStyle({
        width: '100%',
        height: '100%',
        background: _ctx.config?.fillColor || '#000',
        border:
          (_ctx.config?.strokeWidth || 1) +
          'px solid ' +
          (_ctx.config?.outlineColor || '#000'),
        borderRadius: '50%',
      })
                                }, null, 4))
                              : (_ctx.config?.type === 'clipart' && _ctx.config?.name === 'Triangle')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 13,
                                    class: "triangle-clipart",
                                    style: _normalizeStyle({
        borderBottom: '100px solid ' + (_ctx.config?.fillColor || '#000'),
        borderLeft: '50px solid transparent',
        borderRight: '50px solid transparent',
        borderTop: '0 solid transparent',
        borderWidth: '0 50px 100px 50px',
        borderStyle: 'solid',
        width: '0',
        height: '0',
        position: 'absolute',
        left: 'calc(50% - 50px)',
        top: 'calc(50% - 50px)',
      })
                                  }, null, 4))
                                : (_ctx.config?.type === 'text')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 14,
                                      class: "widget-text",
                                      style: _normalizeStyle({
        fontFamily: _ctx.config?.fontFamily || 'Arial',
        fontSize: (_ctx.config?.fontSize || 24) + 'px',
        color: _ctx.config?.fontColor || '#222',
        fontWeight: _ctx.config?.fontWeight === 'bold' ? 'bold' : 'normal',
        fontStyle: _ctx.config?.fontWeight === 'italic' ? 'italic' : 'normal',
        textDecoration:
          _ctx.config?.fontWeight === 'underline' ? 'underline' : 'none',
        textAlign: _ctx.config?.textAlign || 'center',
        letterSpacing: (_ctx.config?.letterSpacing || 0) + 'px',
        wordBreak: 'break-word',
      })
                                    }, _toDisplayString(_ctx.config?.text), 5))
                                  : (_ctx.config?.type === 'ticker')
                                    ? (_openBlock(), _createBlock(Ticker, {
                                        key: 15,
                                        config: _ctx.config
                                      }, null, 8, ["config"]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                        _createElementVNode("span", _hoisted_7, _toDisplayString("Unknown widget type") + ": " + _toDisplayString(_ctx.config?.type), 1)
                                      ]))
  ], 4))
}
}

})